import React from "react"
import { downloadBlob } from "../../../utils/downloadBlob"
import { Anchor, Box, Code, FileInput, List, Text } from "@mantine/core"

interface Props {
  file: File | null
  onFileChange: (file: File | null) => void
  disabled?: boolean
}

export const CsvUploadTab: React.FC<Props> = ({ file, onFileChange, disabled }) => {
  // ヘッダのみのサンプルCSVをダウンロード
  const handleDownloadSample = () => {
    // ExcelでUTF-8として開けるようBOM付き
    const csv = '\uFEFFメールアドレス,ゲストID,名前\n'
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
    downloadBlob(blob, 'incentive_list_sample.csv')
  }

  return (
    <Box>
      <Text fw={600} mb={6}>
        対象者を含むCSVをアップロードしてください
      </Text>
      <List size="sm" mb={12} c="#555">
        <List.Item>
          <Code color="#00000008">メールアドレス</Code> 列 または <Code color="#00000008">ゲストID</Code> 列が必須です
        </List.Item>
        <List.Item>
          <Code color="#00000008">名前</Code> 列は任意（指定すると氏名で絞り込みます）
        </List.Item>
      </List>

      <Box mb={12}>
        <Anchor
          href="#"
          fz={13}
          onClick={(e) => {
            e.preventDefault()
            handleDownloadSample()
          }}
        >
          サンプルCSVをダウンロード
        </Anchor>
      </Box>

      <FileInput
        accept=".csv"
        value={file}
        onChange={onFileChange}
        placeholder="ファイルを選択"
        disabled={disabled}
        w={300}
      />
    </Box>
  )
}
